import $ from 'jquery';
import { Model } from 'backbone';
import { View } from 'backbone';
import contentTemplate from 'behaviors/properties/main/notify/edit-notification-cancellation.ejs';
import Constants from 'Constants'
import formulaModal from 'common-views/MainFormulaModalView';


class EditNotificationCancellationView extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#editNotificationCancellation';
        this.factoryKey = opts.factoryKey;
        this.table = Constants.PROP_MAIN_TABLE_NOTIFICATION_VIEW;
        this.model.set('cancelTypeArray', ["Other", "The instance is opened", "The instance is submitted",
            "The instance's stage has changed", "This condition is met"], {silent:true});
        this.model.set('cancelScopeArray', ["This notification only", "All notifications of this Notify command",
                "All notifications of the instance"], {silent:true});

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }

        this.events = {
            'click #conditionBtn'              : 'showFormulaModal',
            'change input[name=cancelType]' : 'updateRadioAttributes',
            'change input[name=cancelScope]' : 'updateRadioAttributes'
        };

        return this;
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        if (propVal !== '4') {
            $('#conditionBtn').attr('disabled', true);
            $('#conditionBtn').attr('readOnly', true);
        } else {
            $('#conditionBtn').attr('disabled', false);
            $('#conditionBtn').attr('readOnly', false);
        }

        if(propName === 'cancelType'){
            if(propVal === '0'){
                $('#cancelScopes').addClass('disabledPanel');
            }else{
                 $('#cancelScopes').removeClass('disabledPanel');
            }
        }

        $("input[name="+propName+"][value=" + propVal + "]").prop('checked', true);

        switch (propName){
            case 'cancelType':
                this.model.set(propName, propVal);
                this.updateGrid('cancellation', this.model.get('cancelTypeArray')[propVal]);
                this.updateGrid('cancelType', propVal);
                break;
            case 'cancelScope':
                this.model.set(propName, propVal);
                this.updateGrid('cancelScope', propVal);
                break;
        }
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        let id = $(this.table).getGridParam('selrow');
        let rowData = $(this.table).getRowData(id);
        const row = this.model.get("data").filter(row => row.notificationId === rowData.notificationId)[0];
        const attributes = !row.cancelCondition || row.cancelCondition === "" ? {formulaParameter: ""} : { formulaParameter : row.cancelCondition };
        attributes.expressionType = 'scriptingCondition';
        
        var sfModal = new formulaModal({model: new Model(attributes), config: {selected: ''}});
        sfModal.render().then((selectedField)=>{
            this.model.set('cancelCondition', selectedField, {silent:true});
            this.updateGrid('cancelCondition', selectedField);
        }).catch(err => console.log(err));
    }

    updateGrid(field, value) {
        let id = $(this.table).getGridParam('selrow');
        let rowData = $(this.table).getRowData(id);
        rowData[field] = value;
        this.model.get("data").filter(row => row.notificationId === rowData.notificationId)[0][field] = value;
        $(this.table).setRowData(id, rowData);
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        if (this.model.get('cancelType')){
            $("input[name=cancelType][value=" + this.model.get('cancelType') + "]").prop('checked', true);
            if (this.model.get('cancelType') === "4") {
                $('#conditionBtn').attr('disabled', false);
                $('#conditionBtn').attr('readOnly', false);
            } else if(this.model.get('cancelType') === '0'){
                $('#cancelScopes').addClass('disabledPanel');
            }
        }

        if (this.model.get('cancelScope')) {
            $("input[name=cancelScope][value=" + this.model.get('cancelScope') + "]").prop('checked', true);
        }

        return this;

    }
}

export default EditNotificationCancellationView;
